export const DAY_UNIT = "day";
export const MIDNIGHT_TIME = "00:00:00";
export const TIME_FORMAT = "HH:mm:ss";
